import { observable, action } from 'mobx';
import ApiCaller from '../utils/api-caller';
import moment from 'moment';

class BookingTransactionStore {

    // Properties

    // Modal Create/Update Properties

    @observable showBookingTransactionModal = false;
    @observable bookingTransactionTitle = '';

    @observable tabNameActiveKey = '1';
    @observable tabDescriptionActiveKey = '1';

    @observable bookingTransactions = [];
    @observable id = 0;

    @observable name = '';
    @observable nameEnglish = '';
    @observable nameChinese = '';
    @observable nameChineseTraditional = '';
    @observable nameThai = '';
    @observable nameJapanese = '';
    @observable nameVietnamese = '';

    @observable description = '';
    @observable descriptionEnglish = '';
    @observable descriptionChinese = '';
    @observable descriptionChineseTraditional = '';
    @observable descriptionThai = '';
    @observable descriptionJapanese = '';
    @observable descriptionVietnamese = '';

    @observable maxHourPerDay = 0;
    @observable sortOrder = 0;

    @observable itemTextButton = 'Create';
    
    @observable totalData = 0;

    // Helper Properties

    @observable bookingTransactionListLoading = false;
    @observable bookingTransactionModalLoading = false;

    // Initialization

    @action initBookingTransaction(fromDate, endDate, currentPage, pageSize, roomNumber) {
        this.bookingTransactionListLoading = true;

        const languageCode = window.localStorage.getItem('lang') || 'en';

        let fromDateTime = moment(fromDate);
        fromDateTime.hour(0);
        fromDateTime.minute(0);
        fromDateTime.second(0);

        let toDateTime = moment(endDate);
        toDateTime.hour(23);
        toDateTime.minute(59);
        toDateTime.second(0);

        var request = {
            'fromDate': fromDateTime,
            'toDate': toDateTime,
            'currentPage': currentPage,
            'pageSize': pageSize,
            'roomNumber': roomNumber,
            'languageCode': languageCode
        };

        return ApiCaller.BookingTransactions.getSummaryByFilter(request).then(responseFirst => {
            if (responseFirst && responseFirst.isSuccess) {
                let model = responseFirst.model;
                model.map(m => {
                    return m.bookingDate = moment(m.bookingDate).format('DD/MM/yyyy');
                })
                this.bookingTransactions = model;
                this.totalData = responseFirst.totalData;
                this.bookingTransactionListLoading = false;
            } else {
                this.bookingTransactions = [];
                this.totalData = 0;
                this.bookingTransactionListLoading = false;
            }
        });
    }

    @action initCreateBookingTransaction() {
        this.bookingTransactionTitle = 'Create Booking Category';

        this.id = 0;
        this.name = '';
        this.nameEnglish = '';
        this.nameChinese = '';
        this.nameChineseTraditional = '';
        this.nameThai = '';
        this.nameJapanese = '';
        this.nameVietnamese = '';
        this.description = '';
        this.descriptionEnglish = '';
        this.descriptionChinese = '';
        this.descriptionChineseTraditional = '';
        this.descriptionThai = '';
        this.descriptionJapanese = '';
        this.descriptionVietnamese = '';
        this.maxHourPerDay = 0;
        this.sortOrder = 0;
        this.itemTextButton = 'Create';
        this.showBookingTransactionModal = true;
    }

    @action initUpdateBookingTransaction(id) {
        this.bookingTransactionModalLoading = true;
        this.bookingTransactionTitle = 'Update Booking Category';
        this.itemTextButton = 'Save';
        this.showBookingTransactionModal = true;

        ApiCaller.BookingTransactions.getById(id).then(response => {
            if (response && response.isSuccess) {
                var model = response.model;
                this.id = model.id;
                this.name = model.name;
                this.nameEnglish = model.nameLang.english;
                this.nameChinese = model.nameLang.chinese;
                this.nameChineseTraditional = model.nameLang.chineseTraditional;
                this.nameThai = model.nameLang.thai;
                this.nameJapanese = model.nameLang.japanese;
                this.nameVietnamese = model.nameLang.vietnamese;
                this.description = model.description;
                this.descriptionEnglish = model.descriptionLang.english;
                this.descriptionChinese = model.descriptionLang.chinese;
                this.descriptionChineseTraditional = model.descriptionLang.chineseTraditional;
                this.descriptionThai = model.descriptionLang.thai;
                this.descriptionJapanese = model.descriptionLang.japanese;
                this.descriptionVietnamese = model.descriptionLang.vietnamese;
                this.maxHourPerDay = model.maxHourPerDay;
                this.sortOrder = model.sortOrder;
                this.itemTextButton = 'Save';
                this.bookingTransactionModalLoading = false;
            }
        });
    }

    // Transaction

    @action createBookingTransaction() {
        this.bookingTransactionModalLoading = true;

        const request = {
            'name': this.name,
            'nameLang': {
                'english': this.nameEnglish,
                'chinese': this.nameChinese,
                'chineseTraditional': this.nameChineseTraditional,
                'thai': this.nameThai,
                'japanese': this.nameJapanese,
                'vietnamese': this.nameVietnamese
            },
            'description': this.description,
            'descriptionLang': {
                'english': this.descriptionEnglish,
                'chinese': this.descriptionChinese,
                'chineseTraditional': this.descriptionChineseTraditional,
                'thai': this.descriptionThai,
                'japanese': this.descriptionJapanese,
                'vietnamese': this.descriptionVietnamese
            },
            'maxHourPerDay': this.maxHourPerDay,
            'sortOrder': this.sortOrder
        };

        return ApiCaller.BookingTransactions.create(request).then((response) => {
            this.bookingTransactionModalLoading = false;

            if (response && response.isSuccess) {
                this.initBookingTransaction();
                this.showBookingTransactionModal = false;
            }

            return response;
        });
    }

    @action updateBookingTransaction() {
        this.bookingTransactionModalLoading = true;

        const request = {
            'id': this.id,
            'name': this.name,
            'nameLang': {
                'english': this.nameEnglish,
                'chinese': this.nameChinese,
                'chineseTraditional': this.nameChineseTraditional,
                'thai': this.nameThai,
                'japanese': this.nameJapanese,
                'vietnamese': this.nameVietnamese
            },
            'description': this.description,
            'descriptionLang': {
                'english': this.descriptionEnglish,
                'chinese': this.descriptionChinese,
                'chineseTraditional': this.descriptionChineseTraditional,
                'thai': this.descriptionThai,
                'japanese': this.descriptionJapanese,
                'vietnamese': this.descriptionVietnamese
            },
            'maxHourPerDay': this.maxHourPerDay,
            'sortOrder': this.sortOrder
        };

        return ApiCaller.BookingTransactions.update(request).then((response) => {
            this.bookingTransactionModalLoading = false;

            if (response && response.isSuccess) {
                this.initBookingTransaction();
                this.showBookingTransactionModal = false;
            }

            return response;
        });
    }

    @action deleteUpdateBookingTransaction(id) {
        this.bookingTransactionListLoading = true;

        return ApiCaller.BookingTransactions.delete(id).then((response) => {
            this.bookingTransactionListLoading = false;
            if (response && response.isSuccess) {
            }
            return response;
        });
    }

    // SET Properties

    @action setShowBookingTransactionModal(value) {
        this.showBookingTransactionModal = value;
        if (!value) {
            this.tabNameActiveKey = '1';
            this.tabDescriptionActiveKey = '1';
        }
    }

    @action setNameEnglish(value) {
        this.nameEnglish = value;
        this.name = this.nameEnglish;
    }

    @action setNameChinese(value) {
        this.nameChinese = value;
    }

    @action setNameChineseTraditional(value) {
        this.nameChineseTraditional = value;
    }

    @action setNameThai(value) {
        this.nameThai = value;
    }

    @action setNameJapanese(value) {
        this.nameJapanese = value;
    }

    @action setNameVietnamese(value) {
        this.nameVietnamese = value;
    }

    @action setDescriptionEnglish(value) {
        this.descriptionEnglish = value;
        this.description = this.descriptionEnglish;
    }

    @action setDescriptionChinese(value) {
        this.descriptionChinese = value;
    }

    @action setDescriptionChineseTraditional(value) {
        this.descriptionChineseTraditional = value;
    }

    @action setDescriptionThai(value) {
        this.descriptionThai = value;
    }

    @action setDescriptionJapanese(value) {
        this.descriptionJapanese = value;
    }

    @action setDescriptionVietnamese(value) {
        this.descriptionVietnamese = value;
    }

    @action setMaxHourPerDay(value) {
        this.maxHourPerDay = value;
    }

    @action setSortOrder(value) {
        this.sortOrder = value;
    }

    @action setTabNameActiveKey(value) {
        this.tabNameActiveKey = value;
    }

    @action setTabDescriptionActiveKey(value) {
        this.tabDescriptionActiveKey = value;
    }
}

export default new BookingTransactionStore()
